import { FiltroAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/components/FiltroAnaliseLaboratorial/FiltroAnaliseLaboratorial";
import { ItemListCertificado } from "@/contexts/laboratorio/analiseLaboratorial/components/ItemCertificado/ItemListCertificado";
import { useAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/hooks/useAnaliseLaboratorial";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { formatMessageError } from "@/shared/utils/formatMessageError";
import { useQuery } from "@tanstack/react-query";
import {
  App,
  Col,
  Divider,
  Grid,
  List,
  Result,
  Row,
  Space,
  Typography,
} from "antd";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

const PAGE_SIZE = 20;
export function ListaCertificadosAnaliseLaboratorial() {
  const { isOnline } = useNetworkStatus();
  const screens = Grid.useBreakpoint();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getAnalisesLaboratoriaisApi } = useAnaliseLaboratorial();
  const { notification } = App.useApp();
  const page = searchParams.get("page") || "1";
  const currentPage = Number(page);

  const {
    data: listaRequisicoesFiltro,
    isLoading: isLoadingFiltro,
    error: errorRequisicoesFiltro,
    refetch: refetchRequisicoesFiltro,
  } = useQuery({
    queryKey: ["REQUISICOES_FILTRO", searchParams.toString()],
    enabled: isOnline && !!searchParams.get("estabelecimentoId"),
    queryFn: async () => {
      const response = await getAnalisesLaboratoriaisApi({
        estabelecimentoId: Number(searchParams.get("estabelecimentoId")),
        dataColeta: searchParams.get("dataColeta") || undefined,
        codigo: searchParams.get("codigo") || undefined,
        page: currentPage,
      });
      return response;
    },
  });

  useEffect(() => {
    document.title = "Inspeção Mobile - Certificados de Análise Laboratorial";

    if (errorRequisicoesFiltro) {
      const messageError = formatMessageError(errorRequisicoesFiltro);
      notification.error({
        message: "Não foi possivel carregar a lista de requisiçoes.",
        description: messageError,
        key: "error-filtro",
      });
    }
  }, [errorRequisicoesFiltro]);

  if (!isOnline) {
    return <Result title="Sem conexão com a internet" status={"error"} />;
  }

  return (
    <>
      <Space direction="vertical" style={{ width: "100%" }} align="center">
        <Typography.Title
          level={screens.xs ? 4 : 3}
          style={{ textAlign: "center" }}
        >
          Certificados de Análise Laboratorial
        </Typography.Title>
      </Space>

      <Row>
        <Col span={24} style={{ marginTop: 16 }}>
          <FiltroAnaliseLaboratorial />
        </Col>
      </Row>

      <Divider>
        <Typography.Text strong>Resultados da busca</Typography.Text>
      </Divider>
      <List
        size="small"
        bordered
        dataSource={listaRequisicoesFiltro?.content || []}
        renderItem={(item, index) => (
          <ItemListCertificado
            key={index}
            item={item}
            reloadItems={refetchRequisicoesFiltro}
          />
        )}
        loading={isLoadingFiltro}
        pagination={{
          pageSize: PAGE_SIZE,
          position: "bottom",
          defaultCurrent: 1,
          current: Number(page),
          total: listaRequisicoesFiltro?.totalElements || 0,
          showSizeChanger: false,
          onChange: (page) => {
            searchParams.set("page", String(page));
            setSearchParams(searchParams);
          },
          align: "end",
          size: "small",
        }}
      />
    </>
  );
}
